import React from 'react';
import { ToggleSwitch } from '../../ToggleSwitch/ToggleSwitch';
import './ToggleSettingGroup.css';

export interface ToggleSettingGroupItem {
	settingId: string;
	title: string;
	description?: string;
	checked: boolean;
	onChange: (checked: boolean) => void;
	disabled?: boolean;
}

export interface ToggleSettingGroupProps {
	settings: ToggleSettingGroupItem[];
	className?: string;
}

export const ToggleSettingGroup: React.FC<ToggleSettingGroupProps> = ({
	settings,
	className = '',
}) => {
	return (
		<div className={`toggle-setting-group ${className}`}>
			{settings.map((setting) => (
				<div key={setting.settingId} className={`toggle-setting-group-item${setting.disabled ? ' toggle-setting-group-item-disabled' : ''}`}>
					<div className="toggle-setting-group-label">
						<span className="toggle-setting-group-title">{setting.title}</span>
						{setting.description && (
							<span className="toggle-setting-group-description">
								{setting.description}
							</span>
						)}
					</div>
					<ToggleSwitch
						checked={setting.checked}
						onChange={setting.onChange}
						disabled={setting.disabled}
						settingId={setting.settingId}
						ariaLabel={setting.title}
					/>
				</div>
			))}
		</div>
	);
};
